/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mcp_Server_Development_Work_0_DescInputs */

const en_svc_mcp_server_development_work_0_desc = /** @type {(inputs: Svc_Mcp_Server_Development_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tutor that plans with tools and memory behind a cost-capped router, traced end to end.`)
};

const ar_svc_mcp_server_development_work_0_desc = /** @type {(inputs: Svc_Mcp_Server_Development_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`معلم يخطط بالأدوات والذاكرة خلف موجه محدود التكلفة، متتبع من البداية للنهاية.`)
};

const bn_svc_mcp_server_development_work_0_desc = /** @type {(inputs: Svc_Mcp_Server_Development_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`একজন শিক্ষক যে খরচ-সীমিত রাউটারের পেছনে টুল আর স্মৃতি দিয়ে পরিকল্পনা করে, শুরু থেকে শেষ ট্রেস করা।`)
};

const de_svc_mcp_server_development_work_0_desc = /** @type {(inputs: Svc_Mcp_Server_Development_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Tutor, der mit Tools und Gedächtnis hinter einem kostenbegrenzten Router plant, durchgehend getrackt.`)
};

const es_svc_mcp_server_development_work_0_desc = /** @type {(inputs: Svc_Mcp_Server_Development_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un tutor que planifica con herramientas y memoria tras un enrutador con límite de coste, trazado de principio a fin.`)
};

const fr_svc_mcp_server_development_work_0_desc = /** @type {(inputs: Svc_Mcp_Server_Development_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un tuteur qui planifie avec outils et mémoire derrière un routeur à coût plafonné, tracé de bout en bout.`)
};

const pt_svc_mcp_server_development_work_0_desc = /** @type {(inputs: Svc_Mcp_Server_Development_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um tutor que planifica com ferramentas e memória atrás de um router com limite de custo, rastreado de ponta a ponta.`)
};

const zh_svc_mcp_server_development_work_0_desc = /** @type {(inputs: Svc_Mcp_Server_Development_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`带着工具和记忆、在成本受限路由后做规划的家教，全链路可追踪。`)
};

const tr_svc_mcp_server_development_work_0_desc = /** @type {(inputs: Svc_Mcp_Server_Development_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maliyet tavanlı yönlendirici ardında araç ve bellekle planlayan eğitmen, uçtan uca izlenir.`)
};

const ru_svc_mcp_server_development_work_0_desc = /** @type {(inputs: Svc_Mcp_Server_Development_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тьютор, который планирует с инструментами и памятью за роутером с потолком цены, с трассировкой от начала до конца.`)
};

const pl_svc_mcp_server_development_work_0_desc = /** @type {(inputs: Svc_Mcp_Server_Development_Work_0_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutor, który planuje narzędziami i pamięcią za routerem z sufitem kosztów, śledzony end to end.`)
};

/**
* | output |
* | --- |
* | "A tutor that plans with tools and memory behind a cost-capped router, traced end to end." |
*
* @param {Svc_Mcp_Server_Development_Work_0_DescInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mcp_server_development_work_0_desc = /** @type {((inputs?: Svc_Mcp_Server_Development_Work_0_DescInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mcp_Server_Development_Work_0_DescInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mcp_server_development_work_0_desc(inputs)
	if (locale === "bn") return bn_svc_mcp_server_development_work_0_desc(inputs)
	if (locale === "de") return de_svc_mcp_server_development_work_0_desc(inputs)
	if (locale === "es") return es_svc_mcp_server_development_work_0_desc(inputs)
	if (locale === "fr") return fr_svc_mcp_server_development_work_0_desc(inputs)
	if (locale === "pt") return pt_svc_mcp_server_development_work_0_desc(inputs)
	if (locale === "zh") return zh_svc_mcp_server_development_work_0_desc(inputs)
	if (locale === "tr") return tr_svc_mcp_server_development_work_0_desc(inputs)
	if (locale === "ru") return ru_svc_mcp_server_development_work_0_desc(inputs)
	if (locale === "pl") return pl_svc_mcp_server_development_work_0_desc(inputs)
	return en_svc_mcp_server_development_work_0_desc(inputs)
});
export { svc_mcp_server_development_work_0_desc as "svc_mcp-server-development_work_0_desc" }